import type { Session } from '@halo/chat-sdk-react';
import { useIsMyMsg } from '@/scripts/hooks';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgMediaCallTimeoutContentProps } from './msg-media-call-timeout-content';

export interface MsgMediaCallTimeoutProps extends MsgMediaCallTimeoutContentProps {
  session: Session;
}

export const MsgMediaCallTimeout = memo(function MsgMediaCallTimeout({
  message,
  session,
}: MsgMediaCallTimeoutProps) {
  const { t } = useTranslation();
  const isMe = useIsMyMsg(message);

  return (
    <MsgMediaCard message={message} session={session}>
      <MsgMediaCardContent
        session={session}
        message={message}
        isError={true}
        callback={true}
        title={isMe ? t('calls.callTimeoutTitle') : t('calls.callTimeoutTitleReceiver')}
        description={isMe ? t('calls.callTimeout') : t('calls.callTimeoutReceiver')}
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
